import { Trash } from "@phosphor-icons/react";

// Modal dialog for permanently deleting a conversation. Backdrop click
// dismisses when not mid-request; the destructive button uses red glow.
export default function DeleteConfirmDialog({ conv, deleting, onCancel, onConfirm }) {
  if (!conv) return null;
  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center px-4"
      dir="rtl"
      data-testid="messages-delete-confirm"
    >
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={() => !deleting && onCancel()}
        aria-hidden
      />
      <div className="relative w-full max-w-sm bg-white rounded-[24px] shadow-[0_20px_60px_rgba(0,0,0,0.3)] p-6 font-tajawal">
        <div className="mx-auto w-14 h-14 rounded-full bg-[#E0413B]/10 flex items-center justify-center mb-4">
          <Trash size={26} weight="bold" className="text-[#E0413B]" />
        </div>
        <h2 className="text-center font-bold text-[18px] text-[#0A192F] mb-2">حذف المُحادثة نهائياً؟</h2>
        <p className="text-center text-[13px] text-[#5A6470] leading-relaxed mb-6">
          هذه العملية <b className="text-[#E0413B]">غير قابِلة لِالإرجاع</b>.
          ستَختفي المُحادثة وجَميع رسائلها من جِهتك.
          لن تَستطيع استِرجاعها لاحِقاً.
        </p>
        <div className="flex gap-2.5">
          <button
            type="button" onClick={onCancel} disabled={deleting}
            className="flex-1 py-3 rounded-full bg-[#F4F4F2] text-[#0A192F] font-bold text-[14px] active:scale-95 transition disabled:opacity-50"
            data-testid="messages-delete-cancel"
          >
            إلغاء
          </button>
          <button
            type="button" onClick={() => onConfirm(conv)} disabled={deleting}
            className="flex-1 py-3 rounded-full bg-[#E0413B] text-white font-bold text-[14px] active:scale-95 transition disabled:opacity-50 shadow-[0_4px_14px_rgba(224,65,59,0.4)]"
            data-testid="messages-delete-confirm-btn"
          >
            {deleting ? "جارٍ الحَذف…" : "حذف نهائياً"}
          </button>
        </div>
      </div>
    </div>
  );
}
